const typ = { t: 'Typ', name: 'typ-nadwozia', hint: { url: '/type/truck', select: true }}
export default typ